import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59097530&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59097530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59097530')) {
      api.createRecord('59097530', component.options)
    } else {
      api.reload('59097530', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=59097530&scoped=true", function () {
      api.rerender('59097530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/printing/printReceipt/index.vue"
export default component.exports